import { render } from "./RelatedAnime.vue?vue&type=template&id=10deff60"
import script from "./RelatedAnime.vue?vue&type=script&lang=js"
export * from "./RelatedAnime.vue?vue&type=script&lang=js"

import "./RelatedAnime.vue?vue&type=style&index=0&id=10deff60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__